import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled, { CSSProp } from 'styled-components';

export const CardStyled = styled.div<{ $isFilesStep: boolean }>`
  background-color: ${colors.neutral.white};
  padding: 1.6rem 3.2rem;
  box-sizing: border-box;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  margin-bottom: 2.4rem;
  min-height: 10.8rem;
  align-items: center;

  &:last-child {
    margin-bottom: 0;
  }

  ${breakpointsMQ4.md.down} {
    flex-direction: column;
    align-items: flex-start;
  }

  ${({ $isFilesStep }): CSSProp =>
    $isFilesStep &&
    `
    border-left: 10px solid ${colors.green[600]};
    padding-left: 2.2rem;
  `}
`;

export const TitleStyled = styled.h3`
  font-size: 2rem;
  line-height: 2.8rem;
  font-weight: 400;
  letter-spacing: 0.02rem;
  margin: 0 0 0.8rem;
`;

export const TextStyled = styled.p`
  max-width: 40rem;
  margin: 0;
  font-size: 1.4rem;
  line-height: 2rem;
  letter-spacing: 0.02rem;
  color: ${colors.neutral[700]};
`;

export const RightSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;

  ${breakpointsMQ4.md.down} {
    align-items: flex-start;
    width: 100%;
  }
`;
